export default "__VITE_PUBLIC_ASSET__27adec17__"